import _ from 'lodash'
import { useSelectedFeatureId } from 'map-feature-info'
import { MS_UUID, getCategoryMarkerStyle } from 'map-style-utils'
import { Layer, LayerProps } from 'ms-map-gl'
import { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'

import { FeatureIdentifyPlugin } from '~map-preview/App/Map/Plugins/FeatureIdentifyPlugin'
import { HoverPlugin } from '~map-preview/App/Map/Plugins/HoverPlugin'
import { useLayerFilter } from '~map-preview/hooks/useLayerFilter'
import { setLegend } from '~map-preview/states/legend'
import { useMarkerCategory } from '~map-preview/states/marker'
import { getLayerId } from '~map-preview/utils/getLayerId'

export function CategoryLayer(props) {
  const { geojson } = props

  const dispatch = useDispatch()

  const markerCategory = useMarkerCategory()
  const selectedFeatureId = useSelectedFeatureId()
  const filter = useLayerFilter()

  const { legend, symbol } = useMemo(
    () =>
      getCategoryMarkerStyle(geojson, {
        aggregateBoundary: MS_UUID,
        aggregateProperty: markerCategory,
        selected: selectedFeatureId
      }),
    [geojson, markerCategory, selectedFeatureId]
  )

  useEffect(() => {
    dispatch(setLegend(legend))
  }, [dispatch, legend])

  return (
    <>
      <Layer
        {...(symbol as LayerProps)}
        {...(filter as object)}
      />

      <HoverPlugin
        source={_.get(symbol, 'source', '')}
        layer={getLayerId(symbol)}
      />

      <FeatureIdentifyPlugin layer={getLayerId(symbol)} />
    </>
  )
}
